<template>
  <div class="usp-banner aniScreen" v-if="moduleData.horizontalScreenBigPic">
    <!--:style="{backgroundImage:'url(' + moduleData.horizontalScreenBigPic + ')', backgroundRepeat:'no-repeat', backgroundPosition:'center center', backgroundSize: 'center/cover'}"-->
    <div class="usp-banner-top">
      <div></div>
      <div class="usp-banner-title" style="display: none;"></div>
      <div class="usp-banner-btns">
        <a
          :href="moduleData.button1Url"
          class="usp-banner-btn"
          v-if="moduleData.button1Text"
          >{{ moduleData.button1Text }}</a
        >
        <a
          :href="moduleData.button2Url"
          target="blank"
          class="usp-banner-btn"
          v-if="moduleData.button2Text"
          >{{ moduleData.button2Text }}</a
        >
        <a
          :href="moduleData.button3Url"
          target="blank"
          class="usp-banner-btn"
          v-if="moduleData.button3Text"
          >{{ moduleData.button3Text }}</a
        >
      </div>
    </div>
    <img
      :src="moduleData.horizontalScreenBigPic"
      alt=""
      style="width:100%;display:block;"
    />
  </div>
</template>
<script>
export default {
  name: "aniScreen",
  props: {
    moduleData: {
      type: Object,
    },
  },
};
</script>
<style lang="scss">
@import "@style/base";
@import "@style/common";
.usp-banner {
  width: 100%;
  // height: 100vh;
  height: auto;
}
.usp-banner {
  position: relative;
  .usp-banner-top {
    position: absolute;
    left: 0;
    right: 0;
    top: 120px;
    @include media(
      (
        $home-md: (
          top: 168px,
        ),
        $home-sm: (
          top: 108px,
        ),
      )
    );
    .usp-banner-title {
      margin: 0 auto;
      width: 344px;
      height: 115px;
      background: setBgImg(
        "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210629113942992-web_007title@2x.png",
        contain
      );
      @include media(
        (
          $home-bg: (
            width: 250px,
            height: 90px,
          ),
          $home-md: (
            width: 258px,
            height: 90px,
          ),
          $home-sm: (
            width: 230px,
            height: 80px,
          ),
        )
      );
    }
    .usp-banner-btns {
      margin-top: 115px;
      margin-left: auto;
      margin-right: auto;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 616px;
      @include media(
        (
          $home-bg: (
            margin-top: 30px,
          ),
          $home-sm: (
            width: auto,
            margin: 30px 20px 0,
          ),
        )
      );
      @include setThemeClass {
        .usp-banner-btn {
          @include bannerButton(getThemeVal(brandColorWhite));
          flex: 1;
          width: auto;
        }
      }
      .usp-banner-btn + .usp-banner-btn {
        margin-left: 16px;
      }
    }
  }
}
</style>
